import { ReactNode } from 'react'

import type { RoundScore } from '@/types/dde/teamHoleByHole.types'

import { GolfHoleByHoleCells } from './GolfHoleByHoleCells'
import { HoleByHoleRow, HoleByHoleRowHeaderItem } from './styles'
import { TotalScores } from './TotalScores'

interface GolfHoleByHoleRowProps {
  rowData: RoundScore | null
  rowHeader?: ReactNode
  currentRound?: number
  isScoreRow?: boolean
}

export const GolfHoleByHoleRow = ({
  rowData,
  rowHeader,
  currentRound,
  isScoreRow = false
}: GolfHoleByHoleRowProps) => {
  const rowHeaderString = typeof rowHeader === 'string' ? rowHeader : ''
  const isCurrentRound = rowHeaderString[1] === String(currentRound)

  return (
    <HoleByHoleRow isScoreRow={isScoreRow} isCurrentRound={isCurrentRound}>
      <HoleByHoleRowHeaderItem isScoreRow={isScoreRow}>{rowHeader}</HoleByHoleRowHeaderItem>
      <GolfHoleByHoleCells rowData={rowData} rowHeader={rowHeader} isScoreRow={isScoreRow} />
      <TotalScores rowData={rowData} />
    </HoleByHoleRow>
  )
}
